export const LOW_INVENTORY_REQUEST = 'LOW_INVENTORY_REQUEST'
export const LOW_INVENTORY_SUCCESS = 'LOW_INVENTORY_SUCCESS'
export const LOW_INVENTORY_FAIL = 'LOW_INVENTORY_FAIL'
export const LOW_INVENTORY_RESET = 'LOW_INVENTORY_RESET'

export const INVENTORY_MFG_REQUEST = 'INVENTORY_MFG_REQUEST'
export const INVENTORY_MFG_SUCCESS = 'INVENTORY_MFG_SUCCESS'
export const INVENTORY_MFG_FAIL = 'INVENTORY_MFG_FAIL'
export const INVENTORY_MFG_RESET = 'INVENTORY_MFG_RESET'

export const INVENTORY_SUMMARY_REQUEST = 'INVENTORY_SUMMARY_REQUEST'
export const INVENTORY_SUMMARY_SUCCESS = 'INVENTORY_SUMMARY_SUCCESS'
export const INVENTORY_SUMMARY_FAIL = 'INVENTORY_SUMMARY_FAIL'
export const INVENTORY_SUMMARY_RESET = 'INVENTORY_SUMMARY_RESET'
